// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2I_EX","legacyBtn":"MutateMid_legacyBtn__1f52-"};